import { render, staticRenderFns } from "./overpasses-agpz.vue?vue&type=template&id=aefc144a"
import script from "./overpasses-agpz.vue?vue&type=script&lang=js"
export * from "./overpasses-agpz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports